// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1jdWu","buttons":"SendReceipts_buttons__3Bh0z","email":"SendReceipts_email__1FEgN","bookApptTitle":"SendReceipts_bookApptTitle__7ww4e"};